import * as React from 'react';
import { observer } from 'mobx-react';
import { MessageBar, MessageBarType } from 'office-ui-fabric-react/lib/MessageBar';
import strings from 'owa-strings/owa-options-strings';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';

export interface PoliciesErrorMessageBarProps {
    onClickCallback: () => void;
}

/**
 * Creates error message div on get active/available policies error
 * @return error message div
 */
function PoliciesErrorMessageBar(props: PoliciesErrorMessageBarProps) {
    return (
        <MessageBar
            messageBarType={MessageBarType.error}
            isMultiline={false}
            actions={
                <DefaultButton onClick={props.onClickCallback}>
                    {strings.options_retentionPolicies_tryAgain}
                </DefaultButton>
            }>
            {strings.options_retentionPolicies_loadingPoliciesError}
        </MessageBar>
    );
}

export default observer(PoliciesErrorMessageBar);
